(function ($) {
    window.Project = window.Project || {};
    
    Project.carousel = function () {
        $('.faculty-carousel .swiper').each(function (index, element) {
            new Swiper(element, {
                slidesPerView: 3,
                centeredSlides: false,
                spaceBetween: 100,
                autoHeight: true,
                loop: true,
                navigation: {
                    nextEl: ".faculty-carousel .swiper-button-next",
                    prevEl: ".faculty-carousel .swiper-button-prev",
                },
                pagination: {
                    el: ".faculty-carousel .swiper-pagination",
                },
                breakpoints: {
                    576: {
                        slidesPerView: 2,
                        autoHeight: false
                    },
                    992: {
                        slidesPerView: 3,
                        autoHeight: false
                    }
                }
            });
        });

        var max = 0;
        $('.faculty-carousel img').each(function () {
            max = Math.max(max, $(this).height());
        });
        $('.faculty-carousel img').css('height', max);
    };

    $(document).ready(function () {
        Project.carousel();
    });

    $(document).ready(function () {
      var hash = window.location.hash;

      if (hash) {
        var $tabLink = $(
          '[data-bs-target="' + hash + '"], a[href="' + hash + '"]'
        );

        if ($tabLink.length) {
          var tab = new bootstrap.Tab($tabLink[0]);
          tab.show();

          var $collapse = $(hash + ".collapse");
          if ($collapse.length && !$collapse.hasClass("show")) {
            $collapse.collapse("show");
          }

          $("html, body").animate(
            { scrollTop: $(hash).offset().top - 100 },
            500
          );
        }
      }

      $('[data-bs-toggle="pill"], [data-bs-toggle="tab"]').on(
        "shown.bs.tab",
        function (e) {
          var target = $(e.target).attr("data-bs-target");
          if (target) {
            history.replaceState(null, null, target);
          }
        }
      );

      $(".collapse").on("shown.bs.collapse", function () {
        var id = $(this).attr("id");
        if (id) {
          history.replaceState(null, null, "#" + id);
        }
      });
    });

})(jQuery);




